/**
 * Application.js only declares the assets as offered by @lendahand/frontend
 *
 * See https://github.com/lendahand/frontend
 *
 */

import "select2";
import "selectize";
import "../controllers/index";
import "@hotwired/turbo-rails";
import "bootstrap/dist/js/bootstrap.bundle";

document.addEventListener("turbo:before-cache", () => {
  application.controllers.forEach((controller) => {
    if (typeof controller.prepareForCache === "function") {
      controller.prepareForCache();
    }
  });
});
